import WidgetModel from '@mm/state/model/WidgetModel';
import React from 'react';
import { NodeProps } from 'react-flow-renderer';
import { NodeMenu } from './NodeMenu';
import styles from './NodeMenu.module.css';

export const withMenu =
  (Component: React.FC<NodeProps<{ widget: WidgetModel }>>) => props => {
    return (
      <div className={styles.hoverTracker}>
        <Component {...props}>
          <NodeMenu widget={props.data.widget} onEdit={props.data.onEdit} />
        </Component>
      </div>
    );
  };
